export enum SpecialActions {
  AddToNewActivity,
  AddToEvent,
  AddToList,
  AddToTargetView,
  AddActivity,
  AddToNewEmail
}
